import * as React from "react";
import { useTranslation } from "react-i18next";
import BottomSheet from "Components/BottomSheet";
import Const from 'Utils/Consts';
import Icon from "Components/Icon";
import { useSettings } from "Contexts/SettingsContext";

interface IProps {
    title: string
    onCapture: (image: string) => void
    children: any
}

const CaptureImage = (props: IProps) => {
    const [t] = useTranslation()
    const { settings } = useSettings()
    const [open, setOpen] = React.useState(false);
    const width = settings?.REACT_APP_WIDTH != undefined ? settings?.REACT_APP_WIDTH : Const.env.REACT_APP_WIDTH
    const height = settings?.REACT_APP_HEIGHT != undefined ? settings?.REACT_APP_HEIGHT : Const.env.REACT_APP_HEIGHT
    const quality = settings?.REACT_APP_IMAGE_QUALITY != undefined ? settings?.REACT_APP_IMAGE_QUALITY : Const.env.REACT_APP_IMAGE_QUALITY
    const [facingMode, setFacingMode] = React.useState<'environment' | 'user'>('environment');
    const videoRef = React.useRef<HTMLVideoElement>(null);
    const canvasRef = React.useRef<HTMLCanvasElement>(null);

    React.useEffect(() => {
        let stream: MediaStream
        const getCameraStream = async () => {
            try {
                stream = await navigator.mediaDevices.getUserMedia({
                    video: { width: width, height: height, facingMode: facingMode }
                });

                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    if (!videoRef.current.played)
                        videoRef.current.play();
                }
            } catch (error) {
                console.error("Error accessing the camera", error);
            }
        };

        if (open)
            getCameraStream();

        return () => {
            stream?.getTracks()?.forEach(track => track?.stop());
        };
    }, [facingMode, open]);

    const handleCapture = () => {
        if (videoRef.current && canvasRef.current) {
            const context = canvasRef.current.getContext('2d');
            if (context) {
                canvasRef.current.width = width
                canvasRef.current.height = height
                context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
                props.onCapture(canvasRef.current.toDataURL('image/png', quality));
                setOpen(false)
            }
        }
    };

    const handleClickOpen = (e: any) => {
        e.preventDefault();
        setOpen(true);
    };

    const handleClose = (data: any) => {
        setOpen(false)
    };

    return (
        <React.Fragment>
            <div style={{ width: "100%" }} onMouseDown={handleClickOpen}>
                {props.children}
            </div>
            <BottomSheet
                title={props.title}
                visible={open}
                onCancel={() => handleClose(null)}>
                <div
                    style={{
                        width: 50,
                        height: 6,
                        backgroundColor: "#ccc",
                        borderRadius: 3,
                        position: "absolute",
                        top: 8,
                        left: "50%",
                        transform: "translateX(-50%)",
                    }} />
                <div className="overflow-auto px-6 pb-6">
                    <div style={{ position: 'relative', textAlign: 'center', marginTop: 16 }}>
                        <div style={{ position: 'relative' }}>
                            <video
                                ref={videoRef}
                                autoPlay
                                playsInline
                                muted
                                style={{ width: '100%', maxHeight: "500px", objectFit: "cover", objectPosition: "center" }}
                            />
                            <canvas ref={canvasRef} style={{ display: 'none' }} />
                            <Icon name="Cameraswitch"
                                onClick={() => setFacingMode(facingMode == 'environment' ? 'user' : 'environment')}
                                style={{
                                    fontSize: 25,
                                    position: 'absolute',
                                    top: 7,
                                    right: 10,
                                    color: 'rgba(255, 255, 255, 0.7)'
                                }} />
                        </div>
                    </div>
                </div>
                <div className="cta" style={{ padding: "10px" }}>
                    <div style={{ justifyContent: "center", width: "100%", display: "flex" }}>
                        <div onClick={handleCapture} style={{ height: "50px", width: "50px", backgroundColor: "#c0c0c0", borderRadius: "50%", position: "relative" }}>
                            <Icon name="camera" className="w-6 h-6" style={{ height: "30px", width: "30px", position: "absolute", top: "10px", right: "10px", color: "white" }} />
                        </div>
                    </div>
                </div>
            </BottomSheet>
        </React.Fragment>)
}

export default CaptureImage;
